import React, { useEffect, useState } from 'react';
import {
  Dialog,
  Portal,
  CloseButton,
  Input,
  Button,
  VStack,
  Text,
  Box,
  Textarea,
  Image,
  Flex
} from '@chakra-ui/react';
import { COLORS } from '../../../theme';

export default function VideoDialog({
  isOpen,
  onClose,
  mode,
  videoData,
  isSaving,
  onSave
}) {
  const [formData, setFormData] = useState({
    title: '',
    youtubeId: '',
    description: ''
  });

  useEffect(() => {
    if (isOpen) {
      if (videoData) {
        setFormData({
          title: videoData.title || '',
          youtubeId: videoData.youtubeId || '',
          description: videoData.description || ''
        });
      } else {
        setFormData({
          title: '',
          youtubeId: '',
          description: ''
        });
      }
    }
  }, [isOpen, videoData]);

  const handleSave = () => {
    onSave(formData);
  };

  const dialogTitle = mode === 'create' ? 'Add New Video' : 'Edit Video';
  const actionText = mode === 'create' ? 'Add' : 'Save';

  const inputBg = { _light: 'white', _dark: 'gray.900' };
  const borderColor = { _light: 'gray.200', _dark: 'gray.700' };

  return (
    <Dialog.Root
      size="md"
      placement="center"
      motionPreset="slide-in-bottom"
      open={isOpen}
      onOpenChange={(details) => !details.open && onClose()}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header borderBottomWidth="1px" borderColor={borderColor}>
              <Dialog.Title>{dialogTitle}</Dialog.Title>
              <Dialog.CloseTrigger asChild>
                <CloseButton size="sm" />
              </Dialog.CloseTrigger>
            </Dialog.Header>

            <Dialog.Body py={6}>
              <VStack gap={4} align="stretch">
                <Box>
                  <Text fontSize="xs" fontWeight="bold" mb={1}>
                    VIDEO TITLE
                  </Text>
                  <Input
                    placeholder="Enter video title"
                    value={formData.title}
                    onChange={(e) =>
                      setFormData({ ...formData, title: e.target.value })
                    }
                    bg={inputBg}
                  />
                </Box>

                <Box>
                  <Text fontSize="xs" fontWeight="bold" mb={1}>
                    YOUTUBE ID
                  </Text>
                  <Input
                    placeholder="e.g. Bolqtw-OVuo"
                    value={formData.youtubeId}
                    onChange={(e) =>
                      setFormData({ ...formData, youtubeId: e.target.value })
                    }
                    bg={inputBg}
                  />
                  {formData.youtubeId && (
                    <Box
                      mt={2}
                      borderRadius="md"
                      overflow="hidden"
                      boxShadow="sm"
                    >
                      <Image
                        src={`https://img.youtube.com/vi/${formData.youtubeId}/mqdefault.jpg`}
                        alt="Preview"
                        w="full"
                        h="120px"
                        objectFit="cover"
                      />
                    </Box>
                  )}
                </Box>

                <Box>
                  <Text fontSize="xs" fontWeight="bold" mb={1}>
                    DESCRIPTION
                  </Text>
                  <Textarea
                    placeholder="Enter a brief description"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    bg={inputBg}
                    rows={3}
                  />
                </Box>
              </VStack>
            </Dialog.Body>

            <Dialog.Footer borderTopWidth="1px" borderColor={borderColor}>
              <Flex gap={3} justify="flex-end" w="full">
                <Button onClick={onClose} variant="ghost">
                  Cancel
                </Button>
                <Button
                  colorPalette="orange"
                  bg={COLORS.brand.primary}
                  _hover={{ bg: COLORS.brand.hover }}
                  onClick={handleSave}
                  loading={isSaving}
                  px={8}
                >
                  {actionText}
                </Button>
              </Flex>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
